// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file 
 * @author James Reid
 */

// @ts-check

// @@imports-utils
import { crossFadeElements } from "../../utils/index.js"

// @@body
class BlockTabbedContainer extends HTMLElement {
    #activeTab = ""

    constructor() {
        super()
    }

    connectedCallback() {
        // 
        for (const tab of this.querySelectorAll("div.tabs .tab")) {
            if (tab.classList.contains("active")) {
                this.#activeTab = /** @type {any} */ (tab).dataset.tab
            }

            tab.addEventListener("click", () => {
                // 
                if (/** @type {any} */ (tab).dataset.tab === this.#activeTab) {
                    return
                }

                // 
                const previous = /** @type {HTMLElement} */ (this.querySelector(
                    `div.content .tab[data-tab="${this.#activeTab}"]`
                ))
                this.#activeTab = /** @type {any} */ (tab).dataset.tab
                const next = /** @type {HTMLElement} */ (this.querySelector(
                    `div.content .tab[data-tab="${this.#activeTab}"]`
                ))

                // 
                for (const sibling of this.querySelectorAll("div.tabs .tab")) {
                    if (sibling === tab) { continue }
                    sibling.classList.remove("active")
                }
                tab.classList.add("active")
                crossFadeElements(previous, next)

                // 
                const event = new CustomEvent("tab-selected", {
                    detail: this.#activeTab
                })
                this.dispatchEvent(event)
            })
        }

        // 
        for (const content of this.querySelectorAll("div.content .tab")) {
            if (/** @type {any} */ (content).dataset.tab !== this.#activeTab) {
                content.classList.add("closed")
            }
        }
    }

    get activeTab() {
        return this.#activeTab
    }

    static get customName() {
        return "block-tabbed-container"
    }
}

// @@exports
export { BlockTabbedContainer }
